<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Regions</div>

    <div class="divider"></div>
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>
    <div class="divider"></div>

    <div class="view-options" style="display: flex">
      <button mat-button class="icon-btn" (click)="listView = true">
        <svg-icon
          src="assets/svg/list.svg"
          [svgStyle]="{
            'width.px': '26.5',
            'height.px': '23.5'
          }"
          [svgClass]="listView ? 'lightGreen' : 'grey'"
        ></svg-icon>
      </button>
      <button mat-button class="icon-btn" (click)="tileView = true">
        <svg-icon
          src="assets/svg/grid.svg"
          [svgStyle]="{
            'width.px': '26.5',
            'height.px': '26.5'
          }"
          [svgClass]="tileView ? 'lightGreen' : 'grey'"
        ></svg-icon>
      </button>
    </div>

    <div class="divider"></div>
    
  </div>
  <div class="header-right">

    <ng-container *ngIf="!compareRegionMode">
      <div class="search-box input-box">
        <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

        <mat-form-field>
          <input matInput matInput type="text" [formControl]="searchValue" />
        </mat-form-field>
      </div>
      <div class="divider"></div>
    </ng-container>

    <lhpe-select
      *ngIf="tileView"
      controlName="comparisonGroup"
      placeholder="Saved Comparison Groups"
      [formGroup]="regionsForm!"
      [optionIsSelf]="true"
      displayValue="name"
      [options]="availableComparisonGroups"
    >
    </lhpe-select>

    <ng-container *ngIf="tileView">
      <ng-container *ngIf="!compareRegionMode">
        <button
          *ngIf="hasUnselectedRegions && showCreatePalleteBtn"
          mat-button
          color="lightGreen"
          (click)="onCreateNewPaletteAtEnd()"
        >
          Create New Palette
        </button>
      </ng-container>
      <ng-container *ngIf="compareRegionMode">
        <button mat-button color="fiord" (click)="cancelComparisonGroup()">
          Cancel
        </button>
        <button
          *ngIf="comparisonGroup.name"
          mat-button
          color="warn"
          (click)="deleteComparisonGroup()"
        >
          Delete Comparison Group
        </button>
        <button mat-button color="lightGreen" (click)="saveComparisonGroup()">
          Save Comparison Group
        </button>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="tileView">
  <div *ngIf="!compareRegionMode" class="regions">
    <ng-container *ngFor="let region of selectedRegions">
      <div class="container region-container">
        <div class="container-header no-bottom-border">
          <lhpe-select
            *ngIf="region.swapPanelOpen"
            controlName="swapPallete"
            placeholder="Select Region"
            [formGroup]="paletteForm!"
            [optionIsSelf]="true"
            displayValue="name"
            [options]="unselectedRegions"
            (change)="onSwapRegionSelected(region)"
          >
          </lhpe-select>
          <div *ngIf="!region.swapPanelOpen" class="text">
            {{ region.typeName }}: {{ region.name }}
          </div>
          <div class="options">
            <button mat-icon-button [matMenuTriggerFor]="regionMenu">
              <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
            </button>
            <mat-menu
              class="mat-menu-elaphant vertical-menu"
              #regionMenu="matMenu"
            >
              <button
                class="icon-btn-w-text"
                mat-menu-item
                *ngIf="hasUnselectedRegions && showCreatePalleteBtn"
                (click)="onCreateNewPalette(region)"
              >
                <svg-icon
                  src="assets/svg/plus-circle-white.svg"
                  svgClass="white"
                ></svg-icon>
                <span>Create new panel</span>
              </button>

              <button
                class="icon-btn-w-text"
                mat-menu-item
                *ngIf="hasUnselectedRegions"
                (click)="onSwapRegion(region)"
              >
                <svg-icon
                  src="assets/svg/reload.svg"
                  svgClass="white"
                ></svg-icon>
                <span>Swap region</span>
              </button>
              <button
                *ngIf="availableRegions.length > 1"
                class="icon-btn-w-text"
                mat-menu-item
                (click)="onCompareRegions(region)"
              >
                <svg-icon src="assets/svg/compare.svg"></svg-icon>
                <span>Compare regions</span>
              </button>
              <button
                class="icon-btn-w-text"
                mat-menu-item
                (click)="exportToExcel()"
              >
                <svg-icon src="assets/svg/sheet.svg" svgClass="white"></svg-icon>
                <span>Export to Excel</span>
              </button>
              <button
                class="icon-btn-w-text"
                mat-menu-item
                (click)="closePalette(region)"
              >
                <svg-icon
                  src="assets/svg/x-circle.21.5.svg"
                  svgClass="white"
                ></svg-icon>
                <span>Close palette</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="container-content">
          <div class="panels">
            <div class="panel avg-tos-panel">
              <div class="title">Avg TOS</div>
              <div class="icon">
                <svg-icon src="assets/svg/regions/clock.svg"></svg-icon>
              </div>
              <div class="value">{{ region.avg_tos | sToHHMMSSPipe }}</div>
            </div>
            <div class="panel total-visits-panel">
              <div class="title">Total Visits</div>
              <div class="icon">
                <svg-icon src="assets/svg/regions/bar.svg"></svg-icon>
              </div>
              <div class="value">{{ region.total_visits }}</div>
            </div>
            <div class="panel unique-visitors-panel">
              <div class="title">Unique Visitors</div>
              <div class="icon">
                <svg-icon src="assets/svg/regions/pie.svg"></svg-icon>
              </div>
              <div class="value">{{ region.unique_visits }}</div>
            </div>
            <div class="panel avg-visits-freq-panel">
              <div class="title">Avg visit freq</div>
              <div class="icon">
                <svg-icon src="assets/svg/regions/line.svg"></svg-icon>
              </div>
              <div class="value">
                {{ region.avg_visit_freq | number: "1.2-2" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="showCreatePalette && region.createNewPallateSelected"
        class="container region-container add-pallete-container"
      >
        <div class="container-header no-bottom-border">
          <lhpe-select
            controlName="addPallate"
            placeholder="Select Region"
            [formGroup]="paletteForm!"
            [optionIsSelf]="true"
            displayValue="name"
            [options]="unselectedRegions"
            (change)="onAddPalleteChange(region)"
          >
          </lhpe-select>
          <div class="options">
            <button mat-icon-button [matMenuTriggerFor]="newPalleteMenu">
              <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
            </button>
            <mat-menu
              class="mat-menu-elaphant vertical-menu"
              #newPalleteMenu="matMenu"
            >
              <button
                class="icon-btn-w-text"
                mat-menu-item
                (click)="onCloseNewPalette()"
              >
                <svg-icon
                  src="assets/svg/x-circle.21.5.svg"
                  [svgStyle]="{
                    'width.px': '21.5',
                    'height.px': '21.5'
                  }"
                  svgClass="white"
                ></svg-icon>
                <span>Close panel</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="container-content">
          <div class="panels">
            <div class="panel avg-tos-panel">
              <div class="title">Avg TOS</div>
            </div>
            <div class="panel total-visits-panel">
              <div class="title">Total Visits</div>
            </div>
            <div class="panel unique-visitors-panel">
              <div class="title">Unique Visitors</div>
            </div>
            <div class="panel avg-visits-freq-panel">
              <div class="title">Avg visit freq</div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div
      *ngIf="showCreatePaletteAtEnd"
      class="container region-container add-pallete-container"
    >
      <div class="container-header no-bottom-border">
        <lhpe-select
          controlName="addPallate"
          placeholder="Select Region"
          [formGroup]="paletteForm!"
          [optionIsSelf]="true"
          displayValue="name"
          [options]="unselectedRegions"
          (change)="onAddPalleteChange()"
        >
        </lhpe-select>
        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="newPalleteMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu
            class="mat-menu-elaphant vertical-menu"
            #newPalleteMenu="matMenu"
          >
            <button
              class="icon-btn-w-text"
              mat-menu-item
              (click)="onCloseNewPalette()"
            >
              <svg-icon
                src="assets/svg/x-circle.21.5.svg"
                [svgStyle]="{
                  'width.px': '21.5',
                  'height.px': '21.5'
                }"
                svgClass="white"
              ></svg-icon>
              <span>Close panel</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <div class="container-content">
        <div class="panels">
          <div class="panel avg-tos-panel">
            <div class="title">Avg TOS</div>
          </div>
          <div class="panel total-visits-panel">
            <div class="title">Total Visits</div>
          </div>
          <div class="panel unique-visitors-panel">
            <div class="title">Unique Visitors</div>
          </div>
          <div class="panel avg-visits-freq-panel">
            <div class="title">Avg visit freq</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="compareRegionMode" class="heading">Compare Regions</div>

  <div *ngIf="compareRegionMode" class="regions">
    <div
      *ngFor="let region of comparisonGroup.regions"
      class="container region-container"
    >
      <div class="container-header no-bottom-border">
        <lhpe-select
          *ngIf="region.swapPanelOpen"
          controlName="swapPallete"
          placeholder="Select Region"
          [formGroup]="paletteForm!"
          [optionIsSelf]="true"
          displayValue="name"
          [options]="unselectedRegions"
          (change)="onSwapRegionSelected(region)"
        >
        </lhpe-select>
        <div *ngIf="!region.swapPanelOpen" class="text">
          {{ region.typeName }}: {{ region.name }}
        </div>
        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="regionMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu
            class="mat-menu-elaphant vertical-menu"
            #regionMenu="matMenu"
          >
            <button
              class="icon-btn-w-text"
              mat-menu-item
              *ngIf="hasUnselectedRegions && showCreatePalleteBtn"
              (click)="onCreateNewPalette(region)"
            >
              <svg-icon
                src="assets/svg/plus-circle-white.svg"
                svgClass="white"
              ></svg-icon>
              <span>Create new panel</span>
            </button>

            <button
              class="icon-btn-w-text"
              mat-menu-item
              *ngIf="hasUnselectedRegions"
              (click)="onSwapRegion(region)"
            >
              <svg-icon src="assets/svg/reload.svg" svgClass="white"></svg-icon>
              <span>Swap region</span>
            </button>
            <button
                class="icon-btn-w-text"
                mat-menu-item
                (click)="exportToExcel()"
              >
                <svg-icon src="assets/svg/sheet.svg" svgClass="white"></svg-icon>
                <span>Export to Excel</span>
              </button>
            <button
              class="icon-btn-w-text"
              mat-menu-item
              (click)="closePalette(region)"
            >
              <svg-icon
                src="assets/svg/x-circle.21.5.svg"
                svgClass="white"
              ></svg-icon>
              <span>Close palette</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <div class="container-content">
        <div class="panels">
          <div class="panel avg-tos-panel">
            <div class="title">Avg TOS</div>
            <div class="icon">
              <svg-icon src="assets/svg/regions/clock.svg"></svg-icon>
            </div>
            <div class="value">{{ region.avg_tos | sToHHMMSSPipe }}</div>
          </div>
          <div class="panel total-visits-panel">
            <div class="title">Total Visits</div>
            <div class="icon">
              <svg-icon src="assets/svg/regions/bar.svg"></svg-icon>
            </div>
            <div class="value">{{ region.total_visits }}</div>
          </div>
          <div class="panel unique-visitors-panel">
            <div class="title">Unique Visitors</div>
            <div class="icon">
              <svg-icon src="assets/svg/regions/pie.svg"></svg-icon>
            </div>
            <div class="value">{{ region.unique_visits }}</div>
          </div>
          <div class="panel avg-visits-freq-panel">
            <div class="title">Avg visit freq</div>
            <div class="icon">
              <svg-icon src="assets/svg/regions/line.svg"></svg-icon>
            </div>
            <div class="value">
              {{ region.avg_visit_freq | number: "1.2-2" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="showCreatePalette"
      class="container region-container add-pallete-container"
    >
      <div class="container-header no-bottom-border">
        <lhpe-select
          controlName="addPallate"
          placeholder="Select Comparative Region"
          [formGroup]="paletteForm!"
          [optionIsSelf]="true"
          displayValue="name"
          [options]="unselectedRegions"
          (change)="onAddPalleteChange()"
        >
        </lhpe-select>
        <div class="options">
          <button mat-icon-button [matMenuTriggerFor]="newPalleteMenu">
            <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
          </button>
          <mat-menu
            class="mat-menu-elaphant vertical-menu"
            #newPalleteMenu="matMenu"
          >
            <button
              class="icon-btn-w-text"
              mat-menu-item
              (click)="onCloseNewPalette()"
            >
              <svg-icon
                src="assets/svg/x-circle.21.5.svg"
                [svgStyle]="{
                  'width.px': '21.5',
                  'height.px': '21.5'
                }"
                svgClass="white"
              ></svg-icon>
              <span>Close panel</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <div class="container-content">
        <div class="panels">
          <div class="panel avg-tos-panel">
            <div class="title">Avg TOS</div>
          </div>
          <div class="panel total-visits-panel">
            <div class="title">Total Visits</div>
          </div>
          <div class="panel unique-visitors-panel">
            <div class="title">Unique Visitors</div>
          </div>
          <div class="panel avg-visits-freq-panel">
            <div class="title">Avg visit freq</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="add-compare-region"
      *ngIf="hasUnselectedRegions && showCreatePalleteBtn"
    >
      <button mat-icon-button (click)="onCreateNewPalette()">
        <svg-icon src="assets/svg/plus-circle-green.svg"></svg-icon>
      </button>
    </div>
  </div>
</ng-container>
<div [hidden]="!listView" class="list-view">
  <div class="container">
    <div class="container-header no-bottom-border">
      <div class="text">Regions</div>
      <div class="options">
        <button mat-icon-button [matMenuTriggerFor]="broadcastsMenu">
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu class="mat-menu-elaphant" #broadcastsMenu="matMenu">
          <button
            class="icon-btn-w-text"
            mat-menu-item
            (click)="exportToExcel()"
          >
            <svg-icon src="assets/svg/sheet.svg" svgClass="white"></svg-icon>
            <span>Export to Excel</span>
          </button>
        </mat-menu>
      </div>
    </div>
    <div class="container-content">

      <table #regionsTable mat-table [dataSource]="regionsDataSource" matSort>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.name">
              {{ row.typeName }}: {{ row.name }}
            </ng-container>
            <ng-container *ngIf="!row.name"> - </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="avg_tos">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Avg TOS</th>
          <td mat-cell *matCellDef="let row">
            {{ row.avg_tos | sToHHMMSSPipe }}
          </td>
        </ng-container>

        <ng-container matColumnDef="total_visits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Total Visits
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.total_visits }}
          </td>
        </ng-container>

        <ng-container matColumnDef="unique_visits">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Unique Visits
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.unique_visits }}
          </td>
        </ng-container>

        <ng-container matColumnDef="avg_visit_freq">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Avg visit freq
          </th>
          <td mat-cell *matCellDef="let row">
            {{ row.avg_visit_freq | number: "1.2-2" }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage"
      (page)="onPageChange($event)"></mat-paginator>
    </div>
  </div>
</div>
